// import React from 'react';

const Questions = () => {
    return (
        <div class="relative w-full bg-white px-6 py-10 mt-8 sm:mx-auto sm:max-w-4xl sm:rounded-xl">
    <div class="mx-auto text-center">
        <h2 class="text-4xl font-bold tracking-tight text-gray-800 md:text-5xl">
            Frequently asked <span>questions</span>
        </h2>
        <p class="mt-4 text-lg text-gray-600">Your Questions Answered</p>
    </div>
    <div class="mx-auto mt-10 divide-y divide-gray-300">
        <div class="py-5">
        <details class="group bg-white group-open:bg-blue-500">
                <summary class="flex items-center justify-between text-xl font-semibold cursor-pointer text-gray-800 ">
                    <span>Is this tool really free?</span>
                    <span class="transition-transform duration-300 transform group-open:rotate-180">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 9l6 6 6-6"></path>
                        </svg>
                    </span>
                </summary>
                <p class="mt-3 text-gray-600">
                    Yes! Access to our planning tool is completely free with no hidden charges.
                </p>
            </details>
        </div>
        <div class="py-5">
            <details class="group">
                <summary class="flex items-center justify-between text-xl font-semibold cursor-pointer text-gray-800">
                    <span>Will I need to share sensitive information?</span>
                    <span class="transition-transform duration-300 transform group-open:rotate-180">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 9l6 6 6-6"></path>
                        </svg>
                    </span>
                </summary>
                <p class="mt-3 text-gray-600">
                    No, we respect your privacy and do not require any sensitive information for basic use.
                </p>
            </details>
        </div>
        <div class="py-5">
            <details class="group">
                <summary class="flex items-center justify-between text-xl font-semibold cursor-pointer text-gray-800">
                    <span>How will my contact information be used?</span>
                    <span class="transition-transform duration-300 transform group-open:rotate-180">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 9l6 6 6-6"></path>
                        </svg>
                    </span>
                </summary>
                <p class="mt-3 text-gray-600">
                    Your contact information is used only for communication related to our services and updates.
                </p>
            </details>
        </div>
    </div>
</div>
    );
};
export default Questions;